export const templates = {
    com: require("../templates/com.html"),
} as const;
